import React from 'react';
import { Car } from '@phosphor-icons/react';
import { useTranslation } from '../i18n/I18nContext';
import './CarImagePlaceholder.css';
import './small-atoms.css';

/**
 * Компонент-заглушка для изображений автомобилей
 */
const CarImagePlaceholder = ({ make, model, className = '' }) => {
  // useTranslation отдаёт рабочий t() и без провайдера (fallback-ветка в
  // I18nContext), поэтому заглушка не падает вне <I18nProvider>.
  const { t } = useTranslation();

  return (
    <div className={`car-image-placeholder ${className}`.trim()}>
      <Car size={64} className="car-image-placeholder__icon" />
      {(make || model) && (
        <div className="car-image-placeholder__body">
          <p className="car-image-placeholder__title">
            {make} {model}
          </p>
          <p className="car-image-placeholder__note">
            {t('landing.card.imageUnavailable', 'Image not available')}
          </p>
        </div>
      )}
    </div>
  );
};

export default CarImagePlaceholder;
